import { styled } from "@mui/material";
import { TableCell } from "@mui/material";

export const ReportingCell = styled(TableCell)(({ theme }) => ({
  borderColor: "#ccc",
}));
